var map = {
	"./bialystok/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		12564,
		12564
	],
	"./bydgoszcz/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		38603,
		38603
	],
	"./czestochowa/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		11806,
		11806
	],
	"./garwolin/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		19245,
		19245
	],
	"./gdansk/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		5956,
		5956
	],
	"./gdynia/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		92900,
		92900
	],
	"./gliwice/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		70092,
		70092
	],
	"./gmina-swidnica/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		13881,
		13881
	],
	"./kielce/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		13423,
		13423
	],
	"./kolobrzeg/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		75925,
		75925
	],
	"./konskowola/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		4404,
		4404
	],
	"./koszalin/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		25863,
		25863
	],
	"./lask/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		8547,
		8547
	],
	"./lodz/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		13513,
		13513
	],
	"./lublin/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		63668,
		63668
	],
	"./miejsce-piastowe/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		85685,
		85685
	],
	"./mikolow/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		64612,
		64612
	],
	"./naklo/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		23853,
		23853
	],
	"./oborniki/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		71111,
		71111
	],
	"./olesnica/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		8300,
		8300
	],
	"./postomino/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		71480,
		71480
	],
	"./poznan/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		73360,
		73360
	],
	"./przechlewo/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		60007,
		60007
	],
	"./radom/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		84813,
		84813
	],
	"./raszkow/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		94905,
		94905
	],
	"./rawicz/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		50242,
		50242
	],
	"./ryman/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		47041,
		47041
	],
	"./sierakowice/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		47934,
		47934
	],
	"./slawno/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		97990,
		97990
	],
	"./slawoborze/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		86000,
		86000
	],
	"./stare-babice/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		70304,
		70304
	],
	"./szczecin/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		19225,
		19225
	],
	"./szemud/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		28104,
		28104
	],
	"./warszawa/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		48932,
		48932
	],
	"./wloszczowa/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		15883,
		15883
	],
	"./wroclaw/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		44235,
		44235
	],
	"./wyszkow/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		66298,
		66298
	],
	"./zukowo/oplata-za-gospodarowanie-odpadami-komunalnymi/section-1_pl.mdx": [
		21911,
		21911
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 49055;
module.exports = webpackAsyncContext;